import { render, staticRenderFns } from "./rolling.vue?vue&type=template&id=2f829e83&"
import script from "./rolling.vue?vue&type=script&lang=js&"
export * from "./rolling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports